import { TemplateTypes } from 'pages/aaas/hooks';
import { AAATemplate } from 'shared/types/protoc-gen/bffaaa';

export const getTemplateById = (templateId: string, templates: TemplateTypes | undefined) =>
  Object.values(templates || {})
    ?.flat<AAATemplate[]>()
    .find(template => String(template.id).trim().toLowerCase() === templateId.trim().toLowerCase());
